import React from "react";
import styled from "styled-components";
import { Checkmark } from "@sonder/ui/source/icons";
import { getCreatedAtDescriptionFromDate } from "@sonder/ui/source/styled/components/Comment";
import { colors } from "@sonder/ui/source/styled/theme";

interface StyledActionContentProps {
  hasCTA: boolean;
}

const StyledActionContent = styled.div<StyledActionContentProps>`
  align-items: center;
  background-color: ${colors.grayE};
  border-radius: 0.3rem;
  display: ${props => (props.hasCTA ? "flex" : "inline-flex")};
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
`;

interface CompletedAtProps {
  isCompleted: boolean;
}

const StyledCompletedAt = styled.div<CompletedAtProps>`
  align-items: center;
  color: ${props => (props.isCompleted ? colors.greenDark : colors.gray6)};
  display: flex;

  svg {
    width: 1rem;
  }

  svg + span {
    margin-left: 0.5rem;
  }
`;

interface ActionContentProps {
  body: string;
  cta?: React.ReactNode;
  completedAt?: string;
}

export const ActionContent = ({
  body,
  cta,
  completedAt,
}: ActionContentProps) => (
  <StyledActionContent hasCTA={!!cta}>
    <div>
      <div>{body}</div>
      <StyledCompletedAt isCompleted={!!completedAt}>
        {completedAt ? (
          <>
            <Checkmark />
            <span>{getCreatedAtDescriptionFromDate(completedAt)}</span>
          </>
        ) : (
          "Incomplete"
        )}
      </StyledCompletedAt>
    </div>
    {cta}
  </StyledActionContent>
);
